import { QUICK_INFO_BUTTONS } from '@aibees/elephant/components/quick-info-group/components/quick-info-button';
import { useActionButtonContext } from '@aibees/elephant/context/action-button-context';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { ENRICHMENT_STATE } from '@aibees/elephant/types';
import { useEffect } from 'react';

export function useCheckContactDetailsProcessing(item?: PeopleTableInfo) {
  const { removeProcessingItems } = useActionButtonContext();

  useEffect(() => {
    const state = item?.revelation?.contact?.state;
    if (
      !!state &&
      (state === ENRICHMENT_STATE.SUCCESS || state === ENRICHMENT_STATE.FAILED)
    ) {
      removeProcessingItems({
        id: item?.id ?? '',
        type: QUICK_INFO_BUTTONS.CONTACT_ENRICHMENT,
      });
    }
  }, [item]);

  return null;
}
